import React from 'react';
import { NavLink } from 'react-router-dom';

import { ORBIT_PAGE_PATH } from '../constants';

export interface IOrbitNavLinkProps {
  children?: React.ReactNode;
}

/** The Perx Orbit sidebar row: navigates to the full-page workspace. */
const OrbitNavLink: React.FC<IOrbitNavLinkProps> = ({ children }) => (
  <NavLink to={ORBIT_PAGE_PATH}>{children}</NavLink>
);

export default OrbitNavLink;
